export default __webpack_public_path__ + "static/media/sec-3-en.ab394867.png";